import {
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
} from "@mui/material";
import GenericModal from "../../Components/GenericModal";
import { Vocabulary } from "../../Utils/Vocabulary";
import { SketchPicker } from "react-color";
import { useEffect, useState } from "react";
import { endpoints } from "../../Utils/UrlEnum";
import { updateData } from "../../Services/updateData";
import { postData } from "../../Services/postData";
import { OrderStatusModel, OrderTypeModel } from "../../Utils/Models";
import { EWidths } from "../../Utils/Enums";
import { AddOrderStatusModalProps } from "../../Utils/Types";
import { AxiosResponse } from "axios";
import useCustomMemo from "../../Hooks/useCustomMemo";
import { toast } from "react-toastify";

export default function AddOrderStatusModal(props: AddOrderStatusModalProps) {
  const {
    openAddOrderStatusModal,
    selectedRow,
    handleChangeOrderStatusModalValue,
    getOrderStatus,
    sortNumber,
  } = props;
  const [orderStatus, setOrderStatus] = useState<OrderStatusModel>(
    new OrderStatusModel()
  );
  const memo = useCustomMemo();
  const orderTypes = memo?.storage?.orderTypes;

  /**
   *
   */
  useEffect(() => {
    if (selectedRow) setOrderStatus(selectedRow);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRow]);

  /**
   *
   */
  const saveOrderStatus = () => {
    let url = endpoints.orderStatus;
    const newOrderStatus = Object.assign({}, orderStatus) as any;
    if (newOrderStatus.typeId == "") {
      toast.error(Vocabulary.orderStatusTypeIsRequired);
      return;
    }
    if (selectedRow) {
      url += `/${selectedRow._id}`;
      updateData(url, newOrderStatus).then((res: AxiosResponse) => {
        onClose();
        getOrderStatus();
      });
    } else {
      newOrderStatus.sortNumber = sortNumber + 1;
      postData(url, newOrderStatus).then((res: AxiosResponse) => {
        onClose();
        getOrderStatus();
      });
    }
  };

  /**
   *
   */
  const onClose = () => {
    handleChangeOrderStatusModalValue();
    setOrderStatus(new OrderStatusModel());
  };

  return (
    <div>
      <GenericModal
        maxWidth={EWidths.XS}
        open={openAddOrderStatusModal}
        onClose={onClose}
        title={
          selectedRow ? Vocabulary.editOrderStatus : Vocabulary.addOrderStatus
        }
        actions={
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button
              variant="contained"
              style={{
                color: "white",
                backgroundColor: "#4448",
              }}
              onClick={onClose}
            >
              {Vocabulary.cancel}
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={saveOrderStatus}
            >
              {Vocabulary.save}
            </Button>
          </div>
        }
      >
        <div style={{ padding: 10 }}>
          <Grid container spacing={2} alignItems="baseline">
            <Grid item xs={12} md={12} lg={12}>
              <TextField
                type="text"
                required
                label={Vocabulary.status}
                variant="standard"
                disabled={orderStatus?.isDefault}
                fullWidth
                value={orderStatus.name}
                onChange={(event: any) =>
                  setOrderStatus({ ...orderStatus, name: event.target.value })
                }
              />
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
              <FormControl fullWidth>
                <InputLabel>{Vocabulary.orderStatusType}</InputLabel>
                <Select
                  value={
                    orderStatus.typeId
                      ? typeof orderStatus.typeId === "object"
                        ? orderStatus.typeId?._id
                        : orderStatus.typeId
                      : ""
                  }
                  required
                  label={Vocabulary.orderStatusType}
                  onChange={(event: any) =>
                    setOrderStatus({
                      ...orderStatus,
                      typeId: event.target.value,
                    })
                  }
                  fullWidth
                >
                  {orderTypes.map((value: OrderTypeModel, key: number) => (
                    <MenuItem key={key} value={value._id || ""}>
                      {value?.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={12} lg={12}>
              <InputLabel style={{ margin: "10px 0px", fontSize: 15 }}>
                {Vocabulary.chooseStatusColor}
              </InputLabel>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  marginLeft: -15,
                }}
              >
                <SketchPicker
                  disableAlpha={true}
                  width="100%"
                  color={orderStatus.color}
                  onChangeComplete={(color: any) =>
                    setOrderStatus({ ...orderStatus, color: color.hex })
                  }
                />
                <Paper
                  style={{
                    width: "100%",
                    height: 50,
                    marginTop: "30px",
                    marginLeft: 10,
                    backgroundColor: orderStatus.color,
                  }}
                />
              </div>
            </Grid>
          </Grid>
        </div>
      </GenericModal>
    </div>
  );
}
